function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDanger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 35"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16426",
    d: "M13.4 3.4a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 17.2a1.511 1.511 0 1 1 1.507-1.5 1.511 1.511 0 0 1-1.507 1.5zm1.829-12.445-.57 7.692a.21.21 0 0 1-.21.2h-2.1a.21.21 0 0 1-.21-.2l-.57-7.692a1.832 1.832 0 1 1 3.657 0z",
    transform: "translate(-3.4 -3.4)",
    style: {
      fill: "#e55451"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDanger);
export default __webpack_public_path__ + "static/media/error-danger.a93382638a5ea349a53bdd2da4f57c11.svg";
export { ForwardRef as ReactComponent };